import { render, staticRenderFns } from "./BatchNumber.vue?vue&type=template&id=23931c9e&scoped=true&"
import script from "./BatchNumber.vue?vue&type=script&lang=js&"
export * from "./BatchNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23931c9e",
  null
  
)

export default component.exports